import { Box } from 'src/components/UI/Box';
import Typography from 'src/components/Typography';
import { BasicAbstractBackground } from 'src/components/BasicAbstractLayout';
import { TutorialCard } from './TutorialCard';
import { Grid } from 'src/components/UI/Grid';
import { useIsMobile } from 'src/helpers/useIsMobile';
import { GridItem } from '@chakra-ui/react';
import TutorialVideo from './TutorialVideo';
import { useCallback, useContext, useEffect } from 'react';
import { Tracker } from 'src/shared/tracker/Tracker';
import { DialogWrappedComponentProps, FeedbackContext } from 'src/providers/FeedbackProvider';
import {
  trackTutorialEditLogoClick,
  trackTutorialHowToPrescribeClick,
  trackTutorialHowToUseClick,
  trackTutorialsPageView,
} from 'src/services/tracking/events';
import { usePrescriberContext } from 'src/providers/PrescriberProvider';

export interface TutorialItem {
  title: string;
  url: string;
  trackingEvent: (userId?: string) => void;
}

export const TUTORIAL_ITEMS: TutorialItem[] = [
  {
    title: 'Aprenda a editar o logo de suas prescrições',
    url: 'https://www.youtube.com/embed/cxH2J1aRC_U',
    trackingEvent: trackTutorialEditLogoClick,
  },
  {
    title: 'Veja como é fácil prescrever com a Mevo em qualquer lugar',
    url: 'https://www.youtube.com/embed/FpR36s924_w',
    trackingEvent: trackTutorialHowToPrescribeClick,
  },
  {
    title: 'Como utilizar a sua receita digital Mevo',
    url: 'https://www.youtube.com/embed/hJTLrMaoCVs',
    trackingEvent: trackTutorialHowToUseClick,
  },
];

export function TutorialPage() {
  const isMobile = useIsMobile();
  const { openBaseDialog } = useContext(FeedbackContext);
  const { prescriberId } = usePrescriberContext();

  useEffect(() => {
    trackTutorialsPageView(prescriberId || undefined);
  }, [prescriberId]);

  const handleOpenVideo = useCallback(
    async (item: TutorialItem) => {
      Tracker.trackEvent({
        event: `Tutorial Video Opened - ${item.title}`,
      });

      item.trackingEvent(prescriberId || undefined);

      await openBaseDialog((dialogProps: DialogWrappedComponentProps) => <TutorialVideo item={item} />, {
        width: '1280px',
        maxWidth: '90vw',
        height: isMobile ? '40vh' : '720px',
        maxHeight: '90vh',
        overflow: 'visible',
        padding: '0',
        showCloseButton: false,
        backgroundColor: 'transparent',
      });
    },
    [isMobile, openBaseDialog, prescriberId]
  );

  return (
    <BasicAbstractBackground>
      <Box>
        <Box my={'20px'}>
          <Typography model="h1" weight="bold" textAlign={'left'}>
            Conheça nossas funcionalidades e tire suas dúvidas!
          </Typography>
        </Box>
        <Box mx={isMobile ? '' : '100px'} maxWidth="1000px" margin="auto">
          <Grid templateColumns={`repeat(${isMobile ? 1 : 3}, 1fr)`} gap="10px">
            {TUTORIAL_ITEMS.map((item) => (
              <GridItem key={item.title}>
                {/* Condição temporária até todos os videos estarem prontos */}
                {item.url && <TutorialCard {...item} onOpen={() => handleOpenVideo(item)} />}
              </GridItem>
            ))}
          </Grid>
        </Box>
      </Box>
    </BasicAbstractBackground>
  );
}
